export default __webpack_public_path__ + "static/media/full-logo.1faa8b38.png";